module.exports = __webpack_public_path__ + "img/pro_five.29a4a828.jpg";